import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';

function InputSwitch({
    name, value, checked, size, ...props
}) {
    // Default size for backward compatibility
    const defaultSize = 24;
    const defaultBoxSize = 20;

    // If size prop is provided as a number, use it for height; otherwise use default
    const height = typeof size === 'number' ? size : size === '16' ? 16 : defaultSize;
    const width = typeof size === 'number' ? size * 2 : size === '16' ? 27 : defaultSize * 2;
    const boxSize = typeof size === 'number' ? size - 4 : size === '16' ? 12 : defaultBoxSize;
    const translateX = width - boxSize - (height - boxSize);

    const color = checked ? 'green' : 'midGray';
    const transform = checked ? `translateX(${translateX}px)` : 'translateX(0)';

    return (
        <Box
            is='label'
            display='inline-flex'
            borderRadius='full'
            width={width}
            height={height}
            padding={`${(height - boxSize) / 2}px`}
            backgroundColor={color}
            css={{
                cursor: 'pointer',
                transition: 'background-color .1s ease-in',
                ...props.css
            }}
        >
            <input
                {...props}
                type='checkbox'
                value={value ? value : ''}
                name={name}
                checked={checked}
                css={{
                    position: 'absolute',
                    opacity: 0
                }}
            />
            <Box
                size={boxSize}
                borderRadius='full'
                color={color}
                backgroundColor='white'
                css={{
                    transform: transform,
                    transitionProperty: 'transform, color',
                    transitionDuration: '.1s',
                    transitionTimingFunction: 'ease-in'
                }}
            />
        </Box>
    );
}

export default wrapFunctionalComponent(InputSwitch, 'InputSwitch');
